import { z } from 'zod';
import { paginationInput, periodoInput } from './common';

export const caixaStatusEnum = z.enum(['ABERTO', 'FECHADO']);

export const abrirCaixaInput = z.object({
  valorAbertura: z.string(),
});

export const fecharCaixaInput = z.object({
  valorFechamento: z.string(),
});

export const getHistoricoCaixaInput = paginationInput.merge(periodoInput);

export const caixaOutput = z.object({
  id: z.string(),
  userId: z.string(),
  dataAbertura: z.date(),
  dataFechamento: z.date().nullable(),
  valorAbertura: z.string(),
  valorFechamento: z.string().nullable(),
  status: caixaStatusEnum,
  createdAt: z.date(),
});

export const caixaResumoOutput = z.object({
  id: z.string(),
  status: caixaStatusEnum,
  valorAbertura: z.string(),
  totalVendas: z.number(),
  quantidadeVendas: z.number(),
  dataAbertura: z.date(),
  saldoAtual: z.number(),
});

export type AbrirCaixaInput = z.infer<typeof abrirCaixaInput>;
export type FecharCaixaInput = z.infer<typeof fecharCaixaInput>;
export type GetHistoricoCaixaInput = z.infer<typeof getHistoricoCaixaInput>;
export type CaixaOutput = z.infer<typeof caixaOutput>;
export type CaixaResumoOutput = z.infer<typeof caixaResumoOutput>;
